import { fetchShippingMethods, createShipping, fetchShippingId, fetchShipping } from './actions'

export const API_SHIPPING = {
    fetchShippingMethods,
    createShipping,
    fetchShippingId,
    fetchShipping,
}
